"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CouponIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.805 1.261a.822.822 0 011.163 0l1.367 1.367a.822.822 0 010 1.163.468.468 0 00.66.66.822.822 0 011.163 0l1.368 1.368a.822.822 0 010 1.162l-7.323 7.323a.822.822 0 01-1.163 0L1.483 9.746a.822.822 0 010-1.163l7.322-7.322zm2.967 6.4zM9.387 3.005l-.674.674a.823.823 0 01-1.136 1.136l-4.35 4.35 3.395 3.395 4.331-4.332a.823.823 0 011.136-1.135l.692-.693-.322-.322a2.114 2.114 0 01-2.287-.464 2.114 2.114 0 01-.463-2.286l-.322-.323zm-1.242.99l.102-.102-.102.103z",
    clipRule: "evenodd"
  })))
});
CouponIcon.displayName = 'CouponIcon';
var _default = exports.default = CouponIcon;